// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Counter_componentWrapper__0ryn9","input":"Counter_input__Q9gz7","button":"Counter_button__OzOgz"};